module.exports = __webpack_public_path__ + "media/images/pagetop-8ca5a2b6fade632edc4ffba2fe156e39.svg";